import { ChainURL } from '@ankr.com/chains-list';

import { Feature } from '../types';

const keysMap: Record<Feature, keyof ChainURL> = {
  [Feature.GRPC_WEB]: 'grpc',
  [Feature.REST]: 'rest',
  [Feature.RPC]: 'rpc',
};

export const getFeatureKeys = (feature: Feature) => keysMap[feature];
